import { UserAreaBoundary } from "@/components/UserAreaBoundary";
import { Page } from "@/components/layout/Page";
import { DateRangeWidget } from "@/components/widgets/selects/DateRangeWidget";
import { usePagesState } from "@/hooks/usePagesState";
import { FeedingSection } from "@/pages/DashboardPage/fms/sections/FeedingSection";
import { ManagementSoftwareSection } from "@/pages/DashboardPage/fms/sections/ManagementSoftwareSection";
import { MilkingSection } from "@/pages/DashboardPage/fms/sections/MilkingSection";
import { ProactiveSupportSection } from "@/pages/DashboardPage/fms/sections/ProactiveSupportSection";

export function FMSSubpage() {
    const [dateFrom, setDateFrom] = usePagesState("dateFrom");
    const [dateTo, setDateTo] = usePagesState("dateTo");

    const queryParameters = { dateFrom, dateTo };

    return (
        <>
            <Page.StickyHeader>
                <Page.Header.Widgets>
                    <Page.Header.WidgetFrame colSpan={{ md: 12 }}>
                        <DateRangeWidget
                            onDateToChange={(value) => setDateTo(value)}
                            onDateFromChange={(value) => setDateFrom(value)}
                            dateTo={dateTo}
                            dateFrom={dateFrom}
                        />
                    </Page.Header.WidgetFrame>
                </Page.Header.Widgets>
            </Page.StickyHeader>
            <Page>
                <Page.Header>
                    <Page.Header.Widgets>
                        <Page.Header.WidgetFrame colSpan={{ md: 9 }}>
                            <Page.Header.Title value={"Dashboard"} />
                        </Page.Header.WidgetFrame>
                    </Page.Header.Widgets>
                </Page.Header>
                <Page.Content>
                    <Page.Content.Sections>
                        <UserAreaBoundary areas={["ConnectionPerformanceDeviceIndex"]} allowDeveloperMode={true}>
                            <ProactiveSupportSection />
                        </UserAreaBoundary>
                        <MilkingSection
                            queryParameters={queryParameters}
                            setDateFrom={setDateFrom}
                            setDateTo={setDateTo}
                        />
                        <FeedingSection queryParameters={queryParameters} />
                        <ManagementSoftwareSection queryParameters={queryParameters} />
                    </Page.Content.Sections>
                </Page.Content>
            </Page>
        </>
    );
}
